// src/components/CustomerSupportPage/ConfirmationModal.jsx
import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import confirmationIcon from "../assets/images/confirmation-icon.png";
import "../assets/css/--component-statusModal.css";

const ConfirmationModal = ({
  isOpen,
  toggle,
  type = "confirmation", // "confirmation", "error", "success", "warning"
  title,
  message,
  ButtonText,
  ButtonTextYes,
  icon: CustomIcon,
  onCancel,
  onYes,
  isShowYesButton = false
}) => {
  // Default icons based on type
  const getDefaultIcon = () => {
    switch (type) {
      case "error":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#dc3545">
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z" />
          </svg>
        );
      case "confirmation":
        return <img src={confirmationIcon} alt="Confirmation" width="80" height="78" style={{ objectFit: "contain" }} />;
      case "warning":
        return (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#ffc107">
            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-11v6h2v-6h-2zm0-4v2h2V7h-2z" />
          </svg>
        );
      default: // confirmation
        return <img src={confirmationIcon} alt="Confirmation" width="48" height="48" style={{ objectFit: "contain" }} />;
    }
  };

  const handleOk = () => {
    onYes();
  };

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    } else {
      toggle();
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="confirmation-modal">
      {/* Close button */}
      <button type="button" className="btn-close-modal" onClick={toggle} aria-label="Close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>

      <ModalBody className="text-center pt-5 pb-3">
        <div className="modal-icon mb-2">{CustomIcon ? <CustomIcon /> : getDefaultIcon()}</div>
        <h3 className="modal-title fw-600 mb-2">{title}</h3>
        <p className="modal-message">{message}</p>
      </ModalBody>
      <ModalFooter className="border-top-0 pt-0 justify-content-center pb-5">
        {isShowYesButton && <button type="button" className="back-dashboard w-80" onClick={handleOk}>
          {ButtonTextYes ? ButtonTextYes : "Yes"}
        </button>}
        <button type="button" className="back-dashboard w-80" onClick={handleClose}>
          {ButtonText ? ButtonText : "No"}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationModal;
